export class DateConstants {
  public static readonly YearMonthDayWithoutTimeFormat = 'yyyy-MM-dd';
  public static readonly YearMonthDayWithTimeFormat = 'yyyy-MM-dd HH:mm:ss';
  public static readonly YearFormat = 'yyyy';
}
